import { BundleType } from 'swag-common/constants/main-swag.constants';
export const LOGO_LINK = {
  [BundleType.SWAG]: 'https://swag.com/assets/img/swag-logo-blue.jpg',
  [BundleType.DYNAMIC]: 'https://swag.com/assets/img/swag-logo-blue.jpg',
  [BundleType.SENDOSO]: 'https://swag.com/assets/svg/sendoso-black.svg',
  [BundleType.POSTAL]: 'https://swag.com/assets/img/postal-black.svg'
};